import React, {Component} from 'react';
import Project from "./Register"
import Login from './Login'

export default class App extends Component {

	constructor(props)
	{
		super(props);
		this.state={clicked:false,login:false};
		this.navigate=this.navigate.bind(this);
		this.login=this.login.bind(this);
	}

	navigate() {
		this.setState({clicked:true});
	}

	login() {
		this.setState({login:true});
	}
	render(){
		if(this.state.clicked){
    		return(
      			<Project/>
    		);
    	}
    	else if(this.state.login){
    		return(
    			<Login/>
    		);
    	}
		else{
			return(
				<div>
					<div><button type="button" onClick={this.navigate}>GET STARTED</button></div>
					<div><button type="button" onClick={this.login}>Login</button></div>
				</div>
			);
		}
	}
}



/** WEBPACK FOOTER **
 ** ./src/views/App.js
 **/